export const colors = {
  'accent-blue100': '#f7fafc',
  'accent-blue200': '#e5fff9',
  'accent-blue300': '#e5fff9',
  'accent-blue400': '#b0e9e5',
  'accent-blue500': '#3fa8ae',
  'accent-blue600': '#00464f',
  'accent-green100': '#ecf9ee',
  'accent-green200': '#ccf2d2',
  'accent-green300': '#ccf2d2',
  'accent-green400': '#1ec677',
  'accent-green500': '#009c52',
  'accent-green600': '#0d4029',
  'accent-grey100': '#f6f6f6',
  'accent-grey200': '#e5e5e5',
  'accent-grey300': '#e5e5e5',
  'accent-grey400': '#acacac',
  'accent-grey500': '#767676',
  'accent-grey600': '#2a2a2a',
  'accent-pink100': '#fffbfd',
  'accent-pink200': '#fdebff',
  'accent-pink300': '#fdebff',
  'accent-pink400': '#f7bdfe',
  'accent-pink500': '#a455bc',
  'accent-pink600': '#250a2d',
  'accent-red100': '#fffafa',
  'accent-red200': '#ffebeb',
  'accent-red300': '#ffebeb',
  'accent-red400': '#ffbfbf',
  'accent-red500': '#944040',
  'accent-red600': '#450414',
  'accent-yellow100': '#fffdf9',
  'accent-yellow200': '#fdf8cb',
  'accent-yellow300': '#fdf8cb',
  'accent-yellow400': '#ffd600',
  'accent-yellow500': '#ba4627',
  'accent-yellow600': '#702511',
  'bg-action-primary': '#0d4029',
  'bg-action-primary-hover': '#157349',
  'bg-action-secondary': '#ccf2d2',
  'bg-action-secondary-hover': '#eaf3ec',
  'bg-backdrop': '#eaf3ec',
  'bg-inverse': '#1c2923',
  'bg-primary': '#ffffff',
  'bg-raised-primary': '#ffffff',
  'bg-raised-secondary': '#f7faf7',
  'bg-raised-tertiary': '#eaf3ec',
  'bg-secondary': '#f7faf7',
  'bg-tertiary': '#eaf3ec',
  'bg-toast': '#2e3a35',
  'border-action-primary': '#333333',
  'border-inverse': '#2a2a2a',
  'border-primary': '#a8b7b0',
  'border-shade': '#33333314',
  'content-action-inverse': '#ffffff',
  'content-action-primary': '#0D4029',
  'content-dark': '#333333',
  'content-disabled-action-primary': '#157349',
  'content-inverse': '#f7faf7',
  'content-light': '#ffffff',
  'content-primary': '#1C2622',
  'content-secondary': '#8a9791',
  'disabled-action-primary': '#00804066',
  'disabled-inverse': '#ffffff66',
  'disabled-primary': '#33333366',
  'disabled-secondary': '#70737666',
  'shade-inverse100': '#ffffff14',
  'shade-inverse400': '#ffffff66',
  'shade-inverse800': '#ffffffcc',
  'shade-primary100': '#33333314',
  'shade-primary200': '#33333329',
  'shade-primary600': '#333333a3',
  'utility-alert100': '#fbe8ed',
  'utility-alert200': '#f4bac8',
  'utility-alert300': '#e87491',
  'utility-alert400': '#e1466d',
  'utility-alert500': '#d91848',
  'utility-caution100': '#fffdf9',
  'utility-caution200': '#fffbf0',
  'utility-caution300': '#ffefc8',
  'utility-caution400': '#ffc847',
  'utility-caution500': '#e5a513',
  'utility-caution-text': '#b88000',
};

export const darkColors = {
  'accent-blue100': '#00464f',
  'accent-blue200': '#3fa8ae',
  'accent-blue300': '#3fa8ae',
  'accent-blue400': '#b0e9e5',
  'accent-blue500': '#e5fff9',
  'accent-blue600': '#f7fafc',
  'accent-green100': '#0d4029',
  'accent-green200': '#009c52',
  'accent-green300': '#009c52',
  'accent-green400': '#1ec677',
  'accent-green500': '#ccf2d2',
  'accent-green600': '#ecf9ee',
  'accent-grey100': '#2a2a2a',
  'accent-grey200': '#767676',
  'accent-grey300': '#767676',
  'accent-grey400': '#acacac',
  'accent-grey500': '#e5e5e5',
  'accent-grey600': '#f6f6f6',
  'accent-pink100': '#250a2d',
  'accent-pink200': '#a455bc',
  'accent-pink300': '#a455bc',
  'accent-pink400': '#f7bdfe',
  'accent-pink500': '#fdebff',
  'accent-pink600': '#fffbfd',
  'accent-red100': '#450414',
  'accent-red200': '#944040',
  'accent-red300': '#944040',
  'accent-red400': '#ffbfbf',
  'accent-red500': '#ffebeb',
  'accent-red600': '#fffafa',
  'accent-yellow100': '#702511',
  'accent-yellow200': '#ba4627',
  'accent-yellow300': '#ba4627',
  'accent-yellow400': '#ffd600',
  'accent-yellow500': '#fdf8cb',
  'accent-yellow600': '#fffdf9',
  'bg-action-primary': '#ccf2d2',
  'bg-action-primary-hover': '#eaf3ec',
  'bg-action-secondary': '#0d4029',
  'bg-action-secondary-hover': '#009c52',
  'bg-backdrop': '#03140d',
  'bg-inverse': '#ffffff',
  'bg-primary': '#0d1f17',
  'bg-raised-primary': '#1c2923',
  'bg-raised-secondary': '#2e3a35',
  'bg-raised-tertiary': '#0d4029',
  'bg-secondary': '#052316',
  'bg-tertiary': '#1c2923',
  'bg-toast': '#2e3a35',
  'border-action-primary': '#ffffff',
  'border-inverse': '#f6f6f6',
  'border-primary': '#8a9791',
  'border-shade': '#ffffff1a',
  'content-action-inverse': '#333333',
  'content-action-primary': '#ecf9ee',
  'content-dark': '#333333',
  'content-inverse': '#052316',
  'content-light': '#ffffff',
  'content-primary': '#f7faf7',
  'content-secondary': '#a8b7b0',
  'disabled-action-primary': '#1ec67766',
  'disabled-inverse': '#33333366',
  'disabled-primary': '#ffffff66',
  'disabled-secondary': '#d0d3d666',
  'shade-inverse100': '#ffffff14',
  'shade-inverse400': '#ffffff66',
  'shade-inverse800': '#ffffffcc',
  'shade-primary100': '#00000014',
  'shade-primary200': '#00000029',
  'shade-primary600': '#000000a3',
  'utility-alert100': '#320611',
  'utility-alert200': '#580a1d',
  'utility-alert300': '#830d2a',
  'utility-alert400': '#ad1138',
  'utility-alert500': '#d91848',
  'utility-caution100': '#432e00',
  'utility-caution200': '#644500',
  'utility-caution300': '#956700',
  'utility-caution400': '#b88000',
  'utility-caution500': '#e5a513',
  'utility-caution-text': '#ffc847',
};
